import Dialog from './Dialog'

export { Dialog }
export default Dialog
